export default "__VITE_ASSET__DogNceHX__"